import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEarthEurope, faXmark } from "@fortawesome/free-solid-svg-icons";
import { hasPtVersion } from "../../i18n/localizedPath";
import {
    browserPrefersPortuguese,
    dismissLanguagePrompt,
    getLanguagePreference,
    isLanguagePromptDismissed,
    saveLanguagePreference,
} from "../../utils/languagePreference";
import { languageSwitchPath } from "./LanguageSwitcher";
import styles from "./languagePromptBanner.module.scss";

function LanguagePromptBanner() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const [visible, setVisible] = useState(
        () => browserPrefersPortuguese() && !isLanguagePromptDismissed() && getLanguagePreference() === null
    );

    if (!visible || i18n.language === "pt" || !hasPtVersion(location.pathname)) return null;

    const ptT = i18n.getFixedT("pt", "common");
    const to = languageSwitchPath(location.pathname, location.search, location.hash);

    function dismiss() {
        dismissLanguagePrompt();
        setVisible(false);
    }

    return (
        <aside className={styles.banner} lang="pt" aria-label={ptT("languagePrompt.label")}>
            <FontAwesomeIcon icon={faEarthEurope} className={styles.icon} aria-hidden="true" />
            <span className={styles.text}>{ptT("languagePrompt.question")}</span>
            <Link
                to={to}
                hrefLang="pt"
                className={styles.action}
                onClick={() => {
                    saveLanguagePreference("pt");
                    dismissLanguagePrompt();
                    setVisible(false);
                }}
            >
                {ptT("languagePrompt.switch")}
            </Link>
            <button type="button" className={styles.close} onClick={dismiss} aria-label={ptT("languagePrompt.dismiss")}>
                <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
            </button>
        </aside>
    );
}

export default LanguagePromptBanner;
